export const getFrioulVenetieJulienneData = () => ({
  name: "Frioul-Vénétie Julienne",
  country: "Italie",
  description: "Le Frioul-Vénétie Julienne est une région viticole du nord-est de l'Italie, s'étendant des Alpes à l'Adriatique. Cette région produit principalement des vins blancs secs et aromatiques, avec une forte identité locale et des influences slaves.",
  type: "region",
  mapAreas: [
    { region: "Frioul-Vénétie Julienne", x: 55, y: 40, color: "#4B164C", size: 3 }
  ],
  statistics: {
    totalArea: "18,000 ha",
    production: "1.2 million hectolitres",
    appellations: "12 DOC",
    provinces: "4 provinces",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat continental avec influence adriatique, étés chauds et hivers froids",
    soil: "Sols très variés : flysch, calcaire, argile, sable",
    viticulture: "Viticulture traditionnelle, cépages autochtones, vendanges manuelles"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une fraîcheur caractéristique",
    red: "Vins rouges légers et fruités, tannins soyeux",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    orange: "Vins orange traditionnels, macération prolongée"
  },
  history: "La viticulture dans le Frioul-Vénétie Julienne remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la région est reconnue pour ses vins blancs de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine frioulane, poissons, fruits de mer, charcuteries, cuisine slave",
  subregions: {
    "collio": {
      name: "Collio",
      description: "Région prestigieuse produisant des vins blancs secs et aromatiques, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat continental avec influence adriatique",
        soil: "Sols flysch (marnes et grès)",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Friulano", "Ribolla Gialla", "Malvasia Istriana", "Pinot Grigio"],
        red: ["Merlot", "Cabernet Franc", "Refosco"]
      },
      wineStyles: {
        "collio-friulano": "Vins blancs secs et aromatiques",
        "collio-ribolla-gialla": "Vins blancs secs et frais",
        "collio-malvasia": "Vins blancs secs et complexes"
      },
      foodPairing: "Poissons, fruits de mer, volailles, fromages, cuisine frioulane"
    },
    "colli-orientali": {
      name: "Colli Orientali del Friuli",
      description: "Région orientale produisant des vins blancs et rouges de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat continental avec influence adriatique",
        soil: "Sols flysch et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Friulano", "Ribolla Gialla", "Picolit", "Verduzzo"],
        red: ["Refosco", "Schioppettino", "Pignolo"]
      },
      wineStyles: {
        "colli-orientali-friulano": "Vins blancs secs et aromatiques",
        "colli-orientali-picolit": "Vins blancs doux et complexes",
        "colli-orientali-refosco": "Vins rouges structurés et tanniques"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    },
    "grave": {
      name: "Grave del Friuli",
      description: "Région de plaine produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat continental avec influence adriatique",
        soil: "Sols graveleux et sableux",
        viticulture: "Viticulture traditionnelle, vignobles en plaine"
      },
      grapeVarieties: {
        white: ["Friulano", "Pinot Grigio", "Chardonnay", "Sauvignon Blanc"],
        red: ["Merlot", "Cabernet Sauvignon", "Refosco"]
      },
      wineStyles: {
        "grave-friulano": "Vins blancs secs et aromatiques",
        "grave-pinot-grigio": "Vins blancs secs et frais",
        "grave-merlot": "Vins rouges fruités et équilibrés"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    },
    "carso": {
      name: "Carso",
      description: "Région karstique produisant des vins blancs et rouges de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat continental avec influence adriatique",
        soil: "Sols karstiques et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en terrasses"
      },
      grapeVarieties: {
        white: ["Malvasia Istriana", "Vitovska", "Pinot Grigio"],
        red: ["Teran", "Refosco"]
      },
      wineStyles: {
        "carso-malvasia": "Vins blancs secs et aromatiques",
        "carso-vitovska": "Vins blancs secs et complexes",
        "carso-teran": "Vins rouges structurés et tanniques"
      },
      foodPairing: "Poissons, fruits de mer, charcuteries, cuisine karstique"
    }
  }
}); 